// The chrome for a single metric widget on the /settings/usage page: a hairline
// Section heading over the widget's resolved state (skeleton / inline error /
// empty / chart + muted notice). One failed metric never blanks the page. Built
// only on shared `../ui` primitives — no dashboard-authoring coupling. (The
// dashboard board's own tiles live in DashboardWidgetTile.tsx.)

import type { ReactNode } from "react";

import { EmptyState, InlineError, Section, Skeleton, Stack, Text } from "../ui";

export interface WidgetFrameProps {
  children: ReactNode;
  emptyMessage: string;
  heading: string;
  isEmpty: boolean;
  notice?: string | null;
  state: { error: string | null; isLoading: boolean };
}

export function WidgetFrame({
  children,
  emptyMessage,
  heading,
  isEmpty,
  notice,
  state,
}: WidgetFrameProps) {
  return (
    <Section hairline heading={heading}>
      {state.isLoading ? (
        <Skeleton label={`Loading ${heading}`} rows={3} shape="detail-field" />
      ) : null}
      {state.error ? <InlineError>{state.error}</InlineError> : null}
      {!state.isLoading && state.error === null && isEmpty ? (
        <EmptyState description={emptyMessage} title="No data" />
      ) : null}
      {!state.isLoading && state.error === null && !isEmpty ? (
        <Stack gap={2}>
          {children}
          {notice ? <Text variant="muted">{notice}</Text> : null}
        </Stack>
      ) : null}
    </Section>
  );
}
